/**
 * Enum for HTTP codes
 * @enum {number}
 * @readonly
 */
export const HttpStatus = {
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
};

/**
 * Enum for HTTP status labels
 * @enum {string}
 * @readonly
 */
export const HttpStatusLabel = {
  [HttpStatus.SUCCESS]: 'Success',
  [HttpStatus.CREATED]: 'Created',
  [HttpStatus.NO_CONTENT]: 'No Content',
  [HttpStatus.BAD_REQUEST]: 'Bad Request',
  [HttpStatus.UNAUTHORIZED]: 'Unauthorized',
  [HttpStatus.FORBIDDEN]: 'Forbidden',
  [HttpStatus.NOT_FOUND]: 'Not Found',
  [HttpStatus.UNPROCESSABLE_ENTITY]: 'Unprocessable Entity',
  [HttpStatus.INTERNAL_SERVER_ERROR]: 'Internal Server Error',
  [HttpStatus.BAD_GATEWAY]: 'Bad Gateway',
};

/**
 * Query stale time in milliseconds
 * @type {number}
 */
export const QueryStaleTime = 5 * 60 * 1000; // 5-minute cache

/**
 * Query garbage collection time in milliseconds
 * @type {number}
 */
export const QueryGcTime = 5 * 60 * 1000; // 5-minute until garbage collection
